/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@yanolja-rnd/ya-tracker'
import type { CartOrderProductOptions } from '../module/yanolja_clientlog_custom_order/cart-order-product-options'
import type { CouponOptions } from '../module/yanolja/coupon-options'
import type { CashReceiptType } from '../module/yanolja_clientlog_custom_order/cash-receipt-type'
import type { CashReceiptOption } from '../module/yanolja_clientlog_custom_order/cash-receipt-option'
import type { CashReceiptInputEventType } from '../module/yanolja_clientlog_custom_order/cash-receipt-input-event-type'
import type { AmlVerifyIdentificationType } from '../module/yanolja_clientlog_custom_order/aml-verify-identification-type'
import type { CartProductOptions } from '../module/yanolja_clientlog_custom_order/cart-product-options'
import type { CartClickType } from '../module/yanolja_clientlog_custom_order/cart-click-type'
import type { CartPopupType } from '../module/yanolja_clientlog_custom_order/cart-popup-type'

/**
 * PageName: CART_ORDER
 */
export const CartOrderPageLog = {
  FullScreenDialogTitle: {
    /**
     * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 노출
     * https://screen.yanolja.in/tAmZwJHG3rX18vfJ
     *cusomjson 영역에 이미 정의했는데, 이것을 빼내어 표현해주실 수 있나요?
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L5}
     * CartOrderFullScreenDialog
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L115}
     */
    impression({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitle.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 102,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: fullScreenDialogTitle,
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_FULL_SCREEN_DIALOG',
        eventType: 'EVENT_TYPE_IMPR',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleCheckboxMaxDiscountBtn: {
    /**
     * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 최대할인적용체크박스
     * https://screen.yanolja.in/4ZoUfFS6F9LUMWTf
     *앞서 노출에도 남겼지만, objectcontainer를 채우는 것은 현 클라이언트 로그에는 개별 action마다 transactionkey가 없기 때문에
     *분석시 timestamp를 비롯하여 pair를 맞추기 위한 것.
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L18}
     * CartOrderFullScreenDialog
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L115}
     */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleCheckboxMaxDiscountBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 103,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'maxDiscountBtn',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonClickName: {
    /**
     * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 쿠폰 관련
     * https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
     *cusomjson에 정의되어 있는데 편의상 빼내어 표현했음.
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L32}
     * CartOrderFullScreenDialog
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L115}
     */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 104,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: fullScreenDialogClickName,
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonCloseBtn: {
    /**
     * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 닫기 버튼
     * https://screen.yanolja.in/eZD7Yc9bVIvJu5ps
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L45}
     * CartOrderFullScreenDialog
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L115}
     */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonCloseBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 105,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'closeBtn',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonDiscountArea: {
    /**
     * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 반영 버튼
     * https://screen.yanolja.in/ZVjztwCF5LSqPJOu
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L57}
     * CartOrderFullScreenDialog
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L115}
     */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonDiscountArea.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 106,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'discountArea',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitle: {
    /**
     * 주문페이지 -  쿠폰종류 바텀싯 - 노출
     * https://screen.yanolja.in/SXcRkigEjxEXt8mq
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L69}
     * CartOrderBottomSheet
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L142}
     */
    impression({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitle.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 107,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: bottomSheetTitle,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonCloseBtn: {
    /**
     * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 닫기 버튼
     * https://screen.yanolja.in/w11z0JqtROmkhrL4
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L81}
     * CartOrderBottomSheet
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L142}
     */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitleButtonCloseBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 108,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'closeBtn',
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonClickName: {
    /**
     * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 적용 안함 버튼
     * https://screen.yanolja.in/J4rzLkqcN8Tlbwkp
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L93}
     * CartOrderBottomSheet
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L142}
     */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitleButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 109,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: bottomSheetClickName,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonCouponId: {
    /**
     * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 쿠폰 종류
     * https://screen.yanolja.in/qk94A2J5T3pKw7eB
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L105}
     * CartOrderBottomSheet
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L142}
     */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
      couponId,
    }: CartOrderPageLog.BottomSheetTitleButtonCouponId.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 110,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: couponId,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  CartOrderViewInfo: {
    /**
     * 주문페이지 - 통합 예약 페이지 진입
     * 기존 로그 + add_order_page_yn 만 추가
     *스크린 : https://screen.yanolja.in/9uSA5U32D8lwcclZ
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L117}
     * CartOrderViewInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L200}
     */
    view({
      isLogin,
      productOptions,
      availableCouponCount,
      fromCartYn,
      addOrderPageYn,
    }: CartOrderPageLog.CartOrderViewInfo.View) {
      return KinesisTracker.view('CART_ORDER', {
        clientEventId: 420,
        pageName: 'PAGE_NAME_CART_ORDER',
        eventType: 'EVENT_TYPE_VIEW',
        isLogin,
        productOptions,
        availableCouponCount,
        fromCartYn,
        addOrderPageYn,
      })
    },
  },

  NolCardBanner: {
    /**
     * 주문페이지 - 주문서 NOL 카드 배너 노출
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L128}
     * CartOrderClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L215}
     */
    impression({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.NolCardBanner.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 421,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolCard',
        objectContainer: 'nolCardBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },

    /**
     * 주문페이지 - 주문서 NOL 카드 배너 클릭
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L141}
     * CartOrderClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L215}
     */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.NolCardBanner.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 422,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolCard',
        objectContainer: 'nolCardBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PaymentButtonMethod: {
    /**
     * 주문페이지 - 결제수단 선택 클릭
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/0J5vGRnr9vkFDwV9
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L154}
     * CartOrderClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L215}
     */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.PaymentButtonMethod.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 423,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'paymentMethod',
        objectContainer: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PaymentButtonBtn: {
    /**
     * 주문페이지 - 결제하기 버튼 클릭
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/99kFQ7BzDY2cga2Z
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L167}
     * CartOrderClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L215}
     */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.PaymentButtonBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 424,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'paymentBtn',
        objectContainer: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PopupOrderFailed: {
    /**
     * 주문페이지 - 주문 실패 팝업 노출
     * 스크린 : https://screen.yanolja.in/w834gUMGtlV8x4jE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L180}
     * CartOrderPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L222}
     */
    impression({
      hashOrderId,
      popupTitle,
      addOrderPageYn,
    }: CartOrderPageLog.PopupOrderFailed.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 425,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'orderFailedPopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        popupTitle,
        addOrderPageYn,
      })
    },
  },

  BannerTimer: {
    /**
     * 주문페이지 - 타이머 노출
     * 스크린 : https://screen.yanolja.in/r9ygsYfrFl0qJPAV
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L192}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderPageLog.BannerTimer.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 426,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'timer',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  PointTypeCheckboxSave: {
    /**
     * 주문페이지 - (체크박스) 노출 - (어떤 포인트이던) 포인트관련 적립
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L204}
     * CartOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L228}
     */
    impression({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeCheckboxSave.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 470,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'savePoint',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeCheckboxCheckYn: {
    /**
     * 주문페이지 - (모든 체크박스) 클릭 - CJONE 적립하기 영역
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L216}
     * CartOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L228}
     */
    click({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeCheckboxCheckYn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 471,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'checkYn',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeButtonClickName: {
    /**
     * 주문페이지 - (모든 버튼) 클릭 - 포인트 관련 (eg. 전액사용, X(삭제하기), 연동하기 등)
     * 스크린 : https://screen.yanolja.in/als3CqJ82mn7Ae1A
     *################################### 주문 완료(CART_ORDER_COMPLETE) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L228}
     * CartOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L228}
     */
    click({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 472,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PaymentNolMoneyButtonClickName: {
    /**
     * 주문페이지 - 결제수단 NOL머니 관련 클릭 버튼
     * 스크린 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L506}
     * CartOrderNolMoneyClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L236}
     */
    click({
      addOrderPageYn,
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: CartOrderPageLog.PaymentNolMoneyButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 640,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoney',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        addOrderPageYn,
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  PaymentNolMoneyPopupButtonClickName: {
    /**
     * 주문페이지 - 결제하기 버튼 클릭 후 계좌 연결 팝업 - 클릭
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L519}
     * CartOrderNolMoneyPopupClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L244}
     */
    click({
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: CartOrderPageLog.PaymentNolMoneyPopupButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 641,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoneyPopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  NolMoneyCertifyBottomSheetButton: {
    /**
     * 주문페이지 - NOL머니 본인 인증하기 bottomsheet - 클릭
     * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
     *######################### 현금 영수증 로그 ##########################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L532}
     */
    click({}: CartOrderPageLog.NolMoneyCertifyBottomSheetButton.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 642,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolMoneyCertify',
        objectContainer: 'nolMoneyCertifyBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  WidgetCashReceipt: {
    /**
     * 주문페이지 - 현금 영수증 영역 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L545}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L275}
     */
    impression({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.WidgetCashReceipt.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 857,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceipt',
        objectType: 'OBJECT_TYPE_WIDGET',
        eventType: 'EVENT_TYPE_IMPR',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptCheckbox: {
    /**
     * 주문페이지 - 현금 영수증 신청하기 체크박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L557}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L275}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptCheckbox.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 858,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptCheckbox',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptRadioType: {
    /**
     * 주문페이지 - 현금 영수증 라디오 버튼 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L570}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L275}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptRadioType.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 859,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptType',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptDropdownFilter: {
    /**
     * 주문페이지 - 현금 영수증 드롭다운 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L583}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L275}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptDropdownFilter.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 860,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptDropdown',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_DROPDOWN_FILTER',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptTextFieldInput: {
    /**
     * 주문페이지 - 현금 영수증 입력 박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L596}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L275}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptTextFieldInput.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 861,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptInput',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptSelectModalBottomSheetOptionName: {
    /**
     * 주문페이지 - 현금 영수증 신청 선택 모달 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L609}
     * OrderCashReceiptSelectModalClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L283}
     */
    click({ optionName }: CartOrderPageLog.CashReceiptSelectModalBottomSheetOptionName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 862,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'optionName',
        objectContainer: 'cashReceiptSelectModal',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_CLICK',
        optionName,
      })
    },
  },

  SectionNameButtonClick: {
    /**
     * 모웹 - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L707}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L115}
     */
    click({ pageTitle, sectionName, clickName }: CartOrderPageLog.SectionNameButtonClick.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 731,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
      })
    },
  },

  BottomSheetSectionName: {
    /**
     * 모웹 - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L720}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L107}
     */
    impression({ pageTitle, sectionName }: CartOrderPageLog.BottomSheetSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 732,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * PC - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L733}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L115}
     */
    click({ pageTitle, sectionName, clickName }: CartOrderPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 733,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
      })
    },
  },

  PopupSectionName: {
    /**
     * PC - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L746}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L107}
     */
    impression({ pageTitle, sectionName }: CartOrderPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 734,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
      })
    },
  },

  PopupSectionName743: {
    /**
     * 주문 - 3분 이내 동일결제금액 confirm 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L787}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L176}
     */
    impression({ sectionName }: CartOrderPageLog.PopupSectionName743.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 743,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNamePopupClick744: {
    /**
     * 주문 - 3분 이내 동일결제금액 confirm 팝업 - 클릭
     * ################################### 주문 취소 (PAGE_NAME_CART_ORDER_CANCEL) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L800}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L182}
     */
    click({ sectionName, clickName }: CartOrderPageLog.SectionNamePopupClick744.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 744,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderPageLog {
  export namespace FullScreenDialogTitle {
    /**
     * https://screen.yanolja.in/tAmZwJHG3rX18vfJ
     *cusomjson 영역에 이미 정의했는데, 이것을 빼내어 표현해주실 수 있나요?
     */
    export interface Impression {
      /*
       * 주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)
       */
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /* 3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*
       * 4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
       *예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
       */
      fullScreenDialogClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleCheckboxMaxDiscountBtn {
    /**
     * https://screen.yanolja.in/4ZoUfFS6F9LUMWTf
     *앞서 노출에도 남겼지만, objectcontainer를 채우는 것은 현 클라이언트 로그에는 개별 action마다 transactionkey가 없기 때문에
     *분석시 timestamp를 비롯하여 pair를 맞추기 위한 것.
     */
    export interface Click {
      /*
       * 주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)
       */
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /* 3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*
       * 4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
       *예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
       */
      fullScreenDialogClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonClickName {
    /**
     * https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
     *cusomjson에 정의되어 있는데 편의상 빼내어 표현했음.
     */
    export interface Click {
      /*
       * 주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)
       */
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /* 3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*
       * 4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
       *예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
       */
      fullScreenDialogClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonCloseBtn {
    /**
     * https://screen.yanolja.in/eZD7Yc9bVIvJu5ps
     */
    export interface Click {
      /*
       * 주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)
       */
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /* 3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*
       * 4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
       *예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
       */
      fullScreenDialogClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonDiscountArea {
    /**
     * https://screen.yanolja.in/ZVjztwCF5LSqPJOu
     */
    export interface Click {
      /*
       * 주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)
       */
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /* 3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*
       * 4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
       *예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
       */
      fullScreenDialogClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitle {
    /**
     * https://screen.yanolja.in/SXcRkigEjxEXt8mq
     */
    export interface Impression {
      /*
       * 주문페이지에서 각종 바텀싯 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 바텀싯 타이틀은? eg.일반쿠폰 선택, 더하기쿠폰 선택(https://screen.yanolja.in/SXcRkigEjxEXt8mq)
       */
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /* 3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonCloseBtn {
    /**
     * https://screen.yanolja.in/w11z0JqtROmkhrL4
     */
    export interface Click {
      /*
       * 주문페이지에서 각종 바텀싯 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 바텀싯 타이틀은? eg.일반쿠폰 선택, 더하기쿠폰 선택(https://screen.yanolja.in/SXcRkigEjxEXt8mq)
       */
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /* 3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonClickName {
    /**
     * https://screen.yanolja.in/J4rzLkqcN8Tlbwkp
     */
    export interface Click {
      /*
       * 주문페이지에서 각종 바텀싯 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 바텀싯 타이틀은? eg.일반쿠폰 선택, 더하기쿠폰 선택(https://screen.yanolja.in/SXcRkigEjxEXt8mq)
       */
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /* 3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonCouponId {
    /**
     * https://screen.yanolja.in/qk94A2J5T3pKw7eB
     */
    export interface Click {
      /*
       * 주문페이지에서 각종 바텀싯 objecttype에서 획득하는 데이터 schema 목적.
       *1. 정보(상태) - 바텀싯 타이틀은? eg.일반쿠폰 선택, 더하기쿠폰 선택(https://screen.yanolja.in/SXcRkigEjxEXt8mq)
       */
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /* 3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*
       * 추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
       *ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;
       */
      addOrderPageYn: string
      couponId: string
    }
  }
  export namespace CartOrderViewInfo {
    /**
     * 기존 로그 + add_order_page_yn 만 추가
     *스크린 : https://screen.yanolja.in/9uSA5U32D8lwcclZ
     */
    export interface View {
      /* 로그인 유무 ex Y,N*/
      isLogin: string
      /* 주문 상품 정보*/
      productOptions: CartOrderProductOptions
      /* 가능한 쿠폰 건수*/
      availableCouponCount: string
      /* 주문창에서 왔는지 유무*/
      fromCartYn: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace NolCardBanner {
    /**
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /* 지급 방법 ex) TOSS*/
      paymentMethod?: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /* 지급 방법 ex) TOSS*/
      paymentMethod?: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PaymentButtonMethod {
    /**
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/0J5vGRnr9vkFDwV9
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /* 지급 방법 ex) TOSS*/
      paymentMethod?: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PaymentButtonBtn {
    /**
     * 기존 로그 수정
     *스크린 : https://screen.yanolja.in/99kFQ7BzDY2cga2Z
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /* 지급 방법 ex) TOSS*/
      paymentMethod?: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PopupOrderFailed {
    /**
     * 스크린 : https://screen.yanolja.in/w834gUMGtlV8x4jE
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 팝업타이틀 ex) 입장권 수량에 맞게 화담채와 모노레일도 취소해 주세요.*/
      popupTitle: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace BannerTimer {
    /**
     * 스크린 : https://screen.yanolja.in/r9ygsYfrFl0qJPAV
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PointTypeCheckboxSave {
    /**
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /* 체크 여부를 의미함.*/
      checkYn?: boolean
      /* 클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /* 놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeCheckboxCheckYn {
    /**
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /* 체크 여부를 의미함.*/
      checkYn?: boolean
      /* 클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /* 놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeButtonClickName {
    /**
     * 스크린 : https://screen.yanolja.in/als3CqJ82mn7Ae1A
     *################################### 주문 완료(CART_ORDER_COMPLETE) 로그 START ####################################
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /* 체크 여부를 의미함.*/
      checkYn?: boolean
      /* 클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /* 놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PaymentNolMoneyButtonClickName {
    /**
     * 스크린 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     */
    export interface Click {
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /* click_name : https://screen.yanolja.in/HiNEfONERvx1KEhA eg. 로그인, 충전계좌 등록 - 놀머니 가입, 계좌 등록*/
      clickName: string
      /* 놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /* 놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace PaymentNolMoneyPopupButtonClickName {
    /**
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     */
    export interface Click {
      /* click_name : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69 eg.계좌등록하기*/
      clickName: string
      /* 놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /* 놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace NolMoneyCertifyBottomSheetButton {
    /**
     * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
     *######################### 현금 영수증 로그 ##########################
     */
    export interface Click {}
  }
  export namespace WidgetCashReceipt {
    /**
     */
    export interface Impression {
      /* 체크박스 선택 여부*/
      checkYn: boolean
      /* 현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /* 현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /* 사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /* 입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptCheckbox {
    /**
     */
    export interface Click {
      /* 체크박스 선택 여부*/
      checkYn: boolean
      /* 현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /* 현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /* 사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /* 입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptRadioType {
    /**
     */
    export interface Click {
      /* 체크박스 선택 여부*/
      checkYn: boolean
      /* 현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /* 현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /* 사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /* 입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptDropdownFilter {
    /**
     */
    export interface Click {
      /* 체크박스 선택 여부*/
      checkYn: boolean
      /* 현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /* 현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /* 사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /* 입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptTextFieldInput {
    /**
     */
    export interface Click {
      /* 체크박스 선택 여부*/
      checkYn: boolean
      /* 현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /* 현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /* 사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /* 입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptSelectModalBottomSheetOptionName {
    /**
     */
    export interface Click {
      /* 모달에서 선택한 항목 옵션*/
      optionName: CashReceiptOption
    }
  }
  export namespace SectionNameButtonClick {
    /**
     */
    export interface Click {
      /*
       * 놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
       *모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
       *PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L
       */
      pageTitle: string
      sectionName: string
      /* 버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
    }
  }
  export namespace BottomSheetSectionName {
    /**
     */
    export interface Impression {
      /*
       * 놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
       *놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
       *PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L
       */
      pageTitle: string
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick {
    /**
     */
    export interface Click {
      /*
       * 놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
       *모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
       *PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L
       */
      pageTitle: string
      sectionName: string
      /* 버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
    }
  }
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*
       * 놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
       *놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
       *PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L
       */
      pageTitle: string
      sectionName: string
    }
  }
  export namespace PopupSectionName743 {
    /**
     */
    export interface Impression {
      /*
       * 주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
       *결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
       */
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick744 {
    /**
     * ################################### 주문 취소 (PAGE_NAME_CART_ORDER_CANCEL) 로그 START ####################################
     */
    export interface Click {
      /*
       * 주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
       *결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
       */
      sectionName: string
      clickName: string
    }
  }
}

/**
 * PageName: CART_ORDER_COMPLETE
 */
export const CartOrderCompletePageLog = {
  BannerYanoljaClass: {
    /**
     * 주문페이지 야놀자 class 배너 노출
     * 신규 로그
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L242}
     */
    impression({}: CartOrderCompletePageLog.BannerYanoljaClass.Impression = {}) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        clientEventId: 99,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'yanoljaClassBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
      })
    },

    /**
     * 주문페이지 야놀자 class 배너 클릭
     * 신규 로그
     *################################### 주문 리스트 (CART_ORDER_LIST) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L253}
     */
    click({}: CartOrderCompletePageLog.BannerYanoljaClass.Click = {}) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        clientEventId: 101,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'yanoljaClassBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderCompletePageLog {
  export namespace BannerYanoljaClass {
    /**
     * 신규 로그
     */
    export interface Impression {}

    /**
     * 신규 로그
     *################################### 주문 리스트 (CART_ORDER_LIST) 로그 START ####################################
     */
    export interface Click {}
  }
}

/**
 * PageName: CART_ORDER_LIST
 */
export const CartOrderListPageLog = {
  OrderProdInfoButtonWriteReviewBtn: {
    /**
     * 국내 여행 예약 내역 페이지 - 후기 작성 버튼 노출
     * 신규 로그
     *스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L266}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonWriteReviewBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 111,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - 후기 작성 버튼 클릭
     * 수정 로그
     *스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L281}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonWriteReviewBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 112,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  OrderProdInfoButtonQrBtn: {
    /**
     * 국내 여행 예약 내역 페이지 - 모바일 QR 보기 버튼 노출
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L296}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonQrBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 427,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - 모바일 QR 보기 버튼 클릭
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L310}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonQrBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 428,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  ButtonSeeAllBtn: {
    /**
     * 국내 여행 예약 내역 페이지 - N개 상품 더보기 노출
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L324}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderListPageLog.ButtonSeeAllBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 429,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - N개 상품 더보기 클릭
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L336}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderListPageLog.ButtonSeeAllBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 430,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  DmTalkButtonName: {
    /**
     * 국내 여행 예약 내역 페이지 - 노출 - 숙소1:1대화하기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L348}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L341}
     */
    impression({
      buttonName,
      placeNo,
      hashOrderId,
    }: CartOrderListPageLog.DmTalkButtonName.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        inactive: false,
        clientEventId: 663,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - 클릭 - 숙소1:1대화하기
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L361}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L341}
     */
    click({ buttonName, placeNo, hashOrderId }: CartOrderListPageLog.DmTalkButtonName.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        inactive: false,
        clientEventId: 664,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderListPageLog {
  export namespace OrderProdInfoButtonWriteReviewBtn {
    /**
     * 신규 로그
     *스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }

    /**
     * 수정 로그
     *스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }
  }
  export namespace OrderProdInfoButtonQrBtn {
    /**
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }

    /**
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }
  }
  export namespace ButtonSeeAllBtn {
    /**
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace DmTalkButtonName {
    /**
     */
    export interface Impression {
      /* 노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /* 노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /* 주문 정보*/
      hashOrderId: string
    }

    /**
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 START ####################################
     */
    export interface Click {
      /* 노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /* 노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /* 주문 정보*/
      hashOrderId: string
    }
  }
}

/**
 * PageName: CART_ORDER_DETAIL
 */
export const CartOrderDetailPageLog = {
  OrderProdInfoButtonWriteReviewBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - 후기 작성 버튼 노출
     * 신규 로그
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L375}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonWriteReviewBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 113,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - 후기 작성 버튼 클릭
     * 수정 로그
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L389}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonWriteReviewBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 114,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  OrderProdInfoButtonQrBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - 모바일 QR 보기 버튼 노출
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L403}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonQrBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 431,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - 모바일 QR 보기 버튼 클릭
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L417}
     * CartOrderProdCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L169}
     */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonQrBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 432,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  ButtonAddProdOrderBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - 추가 구매 상품 구매하기 버튼 노출
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L431}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    impression({
      hashOrderId,
      addOrderPageYn,
    }: CartOrderDetailPageLog.ButtonAddProdOrderBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 433,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'addProdOrderBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - 추가 구매 상품 구매하기 버튼 클릭
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L443}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonAddProdOrderBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 434,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'addProdOrderBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  ButtonSeeAllBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - N개 상품 더보기 노출
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L455}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonSeeAllBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 435,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - N개 상품 더보기 클릭
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L467}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L210}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonSeeAllBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 436,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  DmTalkButtonName: {
    /**
     * 국내 여행 예약 상세내역 페이지 - 노출 - 숙소1:1대화하기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L479}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L341}
     */
    impression({
      buttonName,
      placeNo,
      hashOrderId,
    }: CartOrderDetailPageLog.DmTalkButtonName.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 665,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },

    /**
     * 국내 여행 예약 상세내역 페이지 - 클릭 - 숙소1:1대화하기
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 END ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L492}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L341}
     */
    click({ buttonName, placeNo, hashOrderId }: CartOrderDetailPageLog.DmTalkButtonName.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 666,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderDetailPageLog {
  export namespace OrderProdInfoButtonWriteReviewBtn {
    /**
     * 신규 로그
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }

    /**
     * 수정 로그
     *국내여행에는 국내숙소 및 레저 모두가 포함됨
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }
  }
  export namespace OrderProdInfoButtonQrBtn {
    /**
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }

    /**
     * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
     *스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*
       * 후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
       *노출 로그에만 남겨주세요.
       */
      activeYn?: boolean
      /*
       * {product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
       *국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad
       */
      productType: string
      /* 국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: number
      /* 국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: number
      /* 국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: number
      /* 레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: number
      /* 레저 상품일 경우 - product_group_id*/
      productGroupId?: number
      /* 레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: number
    }
  }
  export namespace ButtonAddProdOrderBtn {
    /**
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace ButtonSeeAllBtn {
    /**
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Click {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace DmTalkButtonName {
    /**
     */
    export interface Impression {
      /* 노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /* 노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /* 주문 정보*/
      hashOrderId: string
    }

    /**
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 END ####################################
     */
    export interface Click {
      /* 노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /* 노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /* 주문 정보*/
      hashOrderId: string
    }
  }
}

/**
 * PageName: AML_VERIFY
 */
export const AmlVerifyPageLog = {
  PageTitle: {
    /**
     * AML - CDD/EDD - 각종화면 진입
     * CDD 화면: https://screen.yanolja.in/gxCt85O8ah1zbZWO, https://screen.yanolja.in/loDbTSXCuv54rTd0
     *EDD 화면: https://screen.yanolja.in/YqBmwsGQoHEczygZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L622}
     * AmlVerifyView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L287}
     */
    view({ pageTitle }: AmlVerifyPageLog.PageTitle.View) {
      return KinesisTracker.view('AML_VERIFY', {
        inactive: false,
        clientEventId: 656,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'pageTitle',
        eventType: 'EVENT_TYPE_VIEW',
        pageTitle,
      })
    },
  },

  SectionNameButton: {
    /**
     * AML - CDD - 클릭 - 각종 섹션(바텀싯 포함) - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L635}
     * AmlVerifySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L296}
     */
    click({ pageTitle, buttonName, sectionName }: AmlVerifyPageLog.SectionNameButton.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 657,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'buttonName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        buttonName,
        sectionName,
      })
    },
  },

  ButtonName: {
    /**
     * AML - CDD/EDD - 클릭 - 각종 버튼
     * CDD 화면: https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
     *EDD 화면: https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L648}
     * AmlVerifyClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L303}
     */
    click({ pageTitle, buttonName }: AmlVerifyPageLog.ButtonName.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 658,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'buttonName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        buttonName,
      })
    },
  },

  SectionNamePopupTitle: {
    /**
     * AML - CDD/EDD - 노출 - 각종 팝업
     * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
     *EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L662}
     * AmlVerifyPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L310}
     */
    impression({
      pageTitle,
      popupTitle,
      buttonName,
      sectionName,
    }: AmlVerifyPageLog.SectionNamePopupTitle.Impression) {
      return KinesisTracker.impression('AML_VERIFY', {
        inactive: false,
        clientEventId: 659,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'popupTitle',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        popupTitle,
        buttonName,
        sectionName,
      })
    },

    /**
     * AML - CDD 고객확인 - 클릭 - 각종 팝업
     * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
     *EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
     *버튼명이 모두 '확인'으로 popuptitle 로 구분
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L677}
     * AmlVerifyPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L310}
     */
    click({
      pageTitle,
      popupTitle,
      buttonName,
      sectionName,
    }: AmlVerifyPageLog.SectionNamePopupTitle.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 660,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'popupTitle',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        popupTitle,
        buttonName,
        sectionName,
      })
    },
  },

  LabelAmlVerifyIdentification: {
    /**
     * AML - EDD 신분증 등록 시도
     * 로그시점 : EDD 페이지에서 정보 등록하기 버튼을 클릭하여 신분증 등록 API를 호출하는 시점
     *전금망을 통하지 않고도 자체적으로 서비스 내에서 신분증 등록 API 호출 현황을 쉽게 파악하기 위함
     *신분증 종류: 운전면허증, 주민등록증, 외국인 등록증
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L692}
     * AmlVerifyIdentification
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L319}
     */
    bg({
      pageTitle,
      amlVerifyIdentificationType,
    }: AmlVerifyPageLog.LabelAmlVerifyIdentification.Bg) {
      return KinesisTracker.bg('AML_VERIFY', {
        inactive: false,
        clientEventId: 907,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'amlVerifyIdentification',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        pageTitle,
        amlVerifyIdentificationType,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace AmlVerifyPageLog {
  export namespace PageTitle {
    /**
     * CDD 화면: https://screen.yanolja.in/gxCt85O8ah1zbZWO, https://screen.yanolja.in/loDbTSXCuv54rTd0
     *EDD 화면: https://screen.yanolja.in/YqBmwsGQoHEczygZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
     */
    export interface View {
      /*
       * CDD : https://screen.yanolja.in/gxCt85O8ah1zbZWO
       *CDD_제출완료 : https://screen.yanolja.in/loDbTSXCuv54rTd0
       *EDD : https://screen.yanolja.in/YqBmwsGQoHEczygZ
       *EDD_신분증정보확인 : https://screen.yanolja.in/WtephOkkChmWkXeU
       *EDD_제출완료 : https://screen.yanolja.in/d9ysocV8oitzYAZB
       */
      pageTitle: string
    }
  }
  export namespace SectionNameButton {
    /**
     */
    export interface Click {
      /* CDD : https://screen.yanolja.in/gxCt85O8ah1zbZWO*/
      pageTitle: string
      /* 버튼에 적혀있는 내용*/
      buttonName: string
      /* 섹션을 식별하는 이름*/
      sectionName: string
    }
  }
  export namespace ButtonName {
    /**
     * CDD 화면: https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
     *EDD 화면: https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
     */
    export interface Click {
      /*
       * CDD : https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
       *EDD : https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
       */
      pageTitle: string
      /* 버튼에 적혀있는 내용*/
      buttonName: string
    }
  }
  export namespace SectionNamePopupTitle {
    /**
     * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
     *EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
     */
    export interface Impression {
      /*
       * CDD : https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
       *EDD : https://screen.yanolja.in/uya7ddIiVLHh3dEN
       */
      pageTitle: string
      /* 팝업에 노출되는 메세지*/
      popupTitle: string
      /* 버튼에 적혀있는 내용*/
      buttonName?: string
      /* 섹션을 식별하는 이름*/
      sectionName: string
    }

    /**
     * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
     *EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
     *버튼명이 모두 '확인'으로 popuptitle 로 구분
     */
    export interface Click {
      /*
       * CDD : https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
       *EDD : https://screen.yanolja.in/uya7ddIiVLHh3dEN
       */
      pageTitle: string
      /* 팝업에 노출되는 메세지*/
      popupTitle: string
      /* 버튼에 적혀있는 내용*/
      buttonName?: string
      /* 섹션을 식별하는 이름*/
      sectionName: string
    }
  }
  export namespace LabelAmlVerifyIdentification {
    /**
     * 로그시점 : EDD 페이지에서 정보 등록하기 버튼을 클릭하여 신분증 등록 API를 호출하는 시점
     *전금망을 통하지 않고도 자체적으로 서비스 내에서 신분증 등록 API 호출 현황을 쉽게 파악하기 위함
     *신분증 종류: 운전면허증, 주민등록증, 외국인 등록증
     */
    export interface Bg {
      /* EDD : https://screen.yanolja.in/WtephOkkChmWkXeU*/
      pageTitle: string
      /* 신분증 타입*/
      amlVerifyIdentificationType: AmlVerifyIdentificationType
    }
  }
}

/**
 * PageName: CART_ORDER_PAYMENT
 */
export const CartOrderPaymentPageLog = {
  PopupSectionName: {
    /**
     * 결제 - 결제 중 화면닫기 시 confirm 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L760}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L176}
     */
    impression({ sectionName }: CartOrderPaymentPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER_PAYMENT', {
        inactive: false,
        clientEventId: 741,
        pageName: 'PAGE_NAME_CART_ORDER_PAYMENT',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * 결제 - 결제 중 화면닫기 시 confirm 팝업 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L773}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L182}
     */
    click({ sectionName, clickName }: CartOrderPaymentPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('CART_ORDER_PAYMENT', {
        inactive: false,
        clientEventId: 742,
        pageName: 'PAGE_NAME_CART_ORDER_PAYMENT',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderPaymentPageLog {
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*
       * 주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
       *결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
       */
      sectionName: string
    }
  }
  export namespace SectionNamePopupClick {
    /**
     */
    export interface Click {
      /*
       * 주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
       *결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
       */
      sectionName: string
      clickName: string
    }
  }
}

/**
 * PageName: CART_ORDER_CANCEL
 */
export const CartOrderCancelPageLog = {
  PopupCancelFailed: {
    /**
     * 주문 취소 - 취소 요청 실패 팝업 노출
     * 스크린 : https://screen.yanolja.in/NRItxXaxxLodJvMX
     *################################### 장바구니 로그
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L816}
     * CartOrderPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L222}
     */
    impression({
      hashOrderId,
      popupTitle,
      addOrderPageYn,
    }: CartOrderCancelPageLog.PopupCancelFailed.Impression) {
      return KinesisTracker.impression('CART_ORDER_CANCEL', {
        clientEventId: 437,
        pageName: 'PAGE_NAME_CART_ORDER_CANCEL',
        object: 'cancelFailedPopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        popupTitle,
        addOrderPageYn,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderCancelPageLog {
  export namespace PopupCancelFailed {
    /**
     * 스크린 : https://screen.yanolja.in/NRItxXaxxLodJvMX
     *################################### 장바구니 로그
     */
    export interface Impression {
      /* 해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /* 팝업타이틀 ex) 입장권 수량에 맞게 화담채와 모노레일도 취소해 주세요.*/
      popupTitle: string
      /* 추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
}

/**
 * PageName: CART
 */
export const CartPageLog = {
  CartViewInfo: {
    /**
     * 장바구니 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L835}
     * CartViewInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L454}
     */
    view({ productOptions }: CartPageLog.CartViewInfo.View) {
      return KinesisTracker.view('CART', {
        inactive: false,
        clientEventId: 924,
        pageName: 'PAGE_NAME_CART',
        eventType: 'EVENT_TYPE_VIEW',
        productOptions,
      })
    },
  },

  ProductIdLinkCartOption: {
    /**
     * 장바구니 - 클릭 - 상품정보 - 링크
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L845}
     * CartClickInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L458}
     */
    click({ productOption }: CartPageLog.ProductIdLinkCartOption.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 925,
        pageName: 'PAGE_NAME_CART',
        object: 'cartProductOption',
        objectContainer: 'productId',
        objectType: 'OBJECT_TYPE_LINK',
        eventType: 'EVENT_TYPE_CLICK',
        productOption,
      })
    },
  },

  ButtonOrder: {
    /**
     * 장바구니 - 클릭 - 구매하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L860}
     * CartOrderClickInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L463}
     */
    click({ productOptions, packageDiscountAmount, trackCode }: CartPageLog.ButtonOrder.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 926,
        pageName: 'PAGE_NAME_CART',
        object: 'order',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        packageDiscountAmount,
        trackCode,
      })
    },
  },

  ButtonClickName: {
    /**
     * 장바구니 - 클릭 - 각종 버튼 (로그인/예약불가삭제 등)
     * 예약불가삭제 클릭 https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L873}
     * CartClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L458}
     */
    click({ clickName }: CartPageLog.ButtonClickName.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 927,
        pageName: 'PAGE_NAME_CART',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
      })
    },
  },

  ChangeUseTimeBottomSheetButton: {
    /**
     * 장바구니 - 클릭 - 대실시간 변경 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L887}
     * CartChangeUseTime
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L484}
     */
    click({ changeUseTime }: CartPageLog.ChangeUseTimeBottomSheetButton.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 928,
        pageName: 'PAGE_NAME_CART',
        object: 'changeUseTime',
        objectContainer: 'changeUseTimeBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        changeUseTime,
      })
    },
  },

  PopupSectionName: {
    /**
     * 장바구니 - 노출 - 각종 팝업 (대실 시간 변경, 골드클래스 등급하락 구매불가 등)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L902}
     * CartPopupImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L509}
     */
    impression({ sectionName }: CartPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 929,
        pageName: 'PAGE_NAME_CART',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNameButtonClick: {
    /**
     * 장바구니 - 클릭 - 각종 팝업 (대실 시간 변경, 골드클래스 등급하락 구매불가 등)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L916}
     * CartPopupClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L514}
     */
    click({ sectionName, clickName }: CartPageLog.SectionNameButtonClick.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 930,
        pageName: 'PAGE_NAME_CART',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },

  BenefitBannerId: {
    /**
     * 장바구니 - 노출 - 베네핏배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L930}
     * CartBannerImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L489}
     */
    impression({ benefitBannerId, benefitBannerTitle }: CartPageLog.BenefitBannerId.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 931,
        pageName: 'PAGE_NAME_CART',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        benefitBannerId,
        benefitBannerTitle,
      })
    },

    /**
     * 장바구니 - 클릭 - 베네핏배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L944}
     * CartBannerClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L496}
     */
    click({ benefitBannerId, benefitBannerTitle, deepLinkUri }: CartPageLog.BenefitBannerId.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 932,
        pageName: 'PAGE_NAME_CART',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        benefitBannerId,
        benefitBannerTitle,
        deepLinkUri,
      })
    },
  },

  PriceChangeDownInfoBottomSheet: {
    /**
     * 장바구니 - 노출 - 골드클래스 가격인하 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L958}
     * PriceChangeDownInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L520}
     */
    impression({ priceChangedItems }: CartPageLog.PriceChangeDownInfoBottomSheet.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 933,
        pageName: 'PAGE_NAME_CART',
        object: 'priceChangeDownInfo',
        objectContainer: 'priceChangeDownInfoBottomSheet',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        priceChangedItems,
      })
    },
  },

  PriceChangeDownInfoBottomSheetButtonOrder: {
    /**
     * 장바구니 - 클릭 - 골드클래스 가격인하 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L972}
     * PriceChangeDownInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L520}
     */
    click({ priceChangedItems }: CartPageLog.PriceChangeDownInfoBottomSheetButtonOrder.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 934,
        pageName: 'PAGE_NAME_CART',
        object: 'order',
        objectContainer: 'priceChangeDownInfoBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        priceChangedItems,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartPageLog {
  export namespace CartViewInfo {
    /**
     */
    export interface View {
      /* 상품 정보*/
      productOptions?: CartProductOptions[]
    }
  }
  export namespace ProductIdLinkCartOption {
    /**
     */
    export interface Click {
      /* 상품정보클릭 : https://screen.yanolja.in/2FPkEeaI7fskrVGw*/
      productOption: CartProductOptions
    }
  }
  export namespace ButtonOrder {
    /**
     */
    export interface Click {
      /* 구매하기 버튼 클릭 : https://screen.yanolja.in/fVUN1xAllPlaek9Y*/
      productOptions?: CartProductOptions[]
      packageDiscountAmount: number
      /* 유입채널 eg.mkt_googlehotels*/
      trackCode: string
    }
  }
  export namespace ButtonClickName {
    /**
     * 예약불가삭제 클릭 https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
     */
    export interface Click {
      /*
       * 예약불가삭제 클릭 : https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
       *로그인 클릭 : https://screen.yanolja.in/lKXMMgxOXYGbg925
       */
      clickName: CartClickType
    }
  }
  export namespace ChangeUseTimeBottomSheetButton {
    /**
     */
    export interface Click {
      /* 대실 시간 변경 클릭 : https://screen.yanolja.in/02xv0Nb08zCgcceS*/
      changeUseTime: string
    }
  }
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /* 대실시간 변경 : &#34;https://screen.yanolja.in/0h3aMjgJsD3zr81I&#34;*/
      sectionName: CartPopupType
    }
  }
  export namespace SectionNameButtonClick {
    /**
     */
    export interface Click {
      /* 대실시간 변경 : &#34;https://screen.yanolja.in/0h3aMjgJsD3zr81I&#34;*/
      sectionName: CartPopupType
      /* 클릭 버튼에 적혀있는 내용*/
      clickName: string
    }
  }
  export namespace BenefitBannerId {
    /**
     */
    export interface Impression {
      /* 베네핏배너 노출 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ*/
      benefitBannerId: string
      /* 배너타이틀*/
      benefitBannerTitle: string
    }

    /**
     */
    export interface Click {
      /* 베네핏배너 클릭 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ*/
      benefitBannerId: string
      /* 배너타이틀*/
      benefitBannerTitle: string
      /* 배너 진입 uri*/
      deepLinkUri: string
    }
  }
  export namespace PriceChangeDownInfoBottomSheet {
    /**
     */
    export interface Impression {
      /* 골드클래스가격인하 : &#34;https://screen.yanolja.in/rWsCcFPoUBjGsd6t&#34;*/
      priceChangedItems: string
    }
  }
  export namespace PriceChangeDownInfoBottomSheetButtonOrder {
    /**
     */
    export interface Click {
      /* 골드클래스가격인하 : &#34;https://screen.yanolja.in/rWsCcFPoUBjGsd6t&#34;*/
      priceChangedItems: string
    }
  }
}
